module.exports = __webpack_public_path__ + "img/palmas-room-3.accd5429.jpg";